<script setup lang="ts" generic="T">
import { computed } from 'vue';

defineEmits(['update:modelValue']);

const props = defineProps<{
  appearanceNone?: boolean;
  disabled?: boolean;
  position?: 'first' | 'last' | 'middle';
  selected?: boolean;
}>();

const borderUtils = computed(() => {
  if (!props.position) {
    if (props.selected) return 'border rounded-lg border-black bg-neutral-100';
    return 'border border-neutral-200 rounded-lg';
  }
  if (props.position === 'first') {
    if (props.selected) return 'border rounded-t-lg border-black bg-neutral-100';
    return 'border border-neutral-200 rounded-t-lg';
  }
  if (props.position === 'last') {
    if (props.selected) return 'border rounded-b-lg border-black bg-neutral-100';
    return 'border-b border-x rounded-b-lg border-neutral-200 custom-top-border';
  }
  if (props.selected) {
    return 'border border-black bg-neutral-100';
  }
  return 'border-b border-x border-neutral-200 custom-top-border';
});

const hoverUtils = computed(() => {
  if (props.disabled) return 'text-neutral-400 cursor-not-allowed';
  if (props.appearanceNone) return '';

  return 'cursor-pointer hover:bg-neutral-100';
});
</script>

<template>
  <div
    class="relative px-4 py-3 text-sm border-solid md:text-base"
    :class="[borderUtils, hoverUtils]"
  >
    <slot />
  </div>
</template>

<style scoped>
.custom-top-border {
  border-top-width: 1px;
  border-top-color: transparent;
}
</style>
